var overridableReplacements = [['&', ' and '], ['🦄', ' unicorn '], ['♥', ' love ']];
export default overridableReplacements;